
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podminky-pouzivani",
      function () {
        return require("private-next-pages/podminky-pouzivani.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podminky-pouzivani"])
      });
    }
  